import React from 'react';

const Trash = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="26"
      viewBox="0 0 20 26"
    >
      <defs>
        <path
          d="M16.5,1.5 C17.6,1.5 18.5,2.4 18.5,3.5 L18.5,3.5 L18.5,4.5 L23.5,4.5 L23.5,5.5 L22.45,5.5 L21.5,24.5 C21.5,25.6 20.6,26.5 19.5,26.5 L19.5,26.5 L8.5,26.5 C7.4,26.5 6.5,25.6 6.5,24.5 L6.5,24.5 L5.55,5.5 L4.5,5.5 L4.5,4.5 L9.5,4.5 L9.5,3.5 C9.5,2.4 10.4,1.5 11.5,1.5 L11.5,1.5 Z M21.45,5.55 L6.55,5.55 L7.5,24.5 L7.5067602,24.616199 C7.56479592,25.1119898 7.98928571,25.5 8.5,25.5 L8.5,25.5 L19.5,25.5 C20.05,25.5 20.5,25.05 20.5,24.5 L20.5,24.5 L21.45,5.55 Z M14.5,7.5 L14.5,23.5 L13.5,23.5 L13.5,7.5 L14.5,7.5 Z M10.5,7.5 L11.5,23.5 L10.5,23.5 L9.5,7.5 L10.5,7.5 Z M18.5,7.5 L17.5,23.5 L16.5,23.5 L17.5,7.5 L18.5,7.5 Z M16.5,2.5 L11.5,2.5 C10.95,2.5 10.5,2.95 10.5,3.5 L10.5,3.5 L10.5,4.5 L17.5,4.5 L17.5,3.5 C17.5,2.95 17.05,2.5 16.5,2.5 L16.5,2.5 Z"
          id="path-1"
        ></path>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="paiement-à-table---Ecran-1---mono-V1-Copy-3"
          transform="translate(-334.000000, -102.000000)"
        >
          <g
            id="Icons-/-Navigation-or-Toolbar-/-Trash"
            transform="translate(330.000000, 101.000000)"
          >
            <mask id="mask-2" fill="white">
              <use href="#path-1"></use>
            </mask>
            <use
              id="Mask"
              fill="#007AFF"
              fillRule="evenodd"
              href="#path-1"
            ></use>
            <g
              id="Icons-/-Colors-/-Tint"
              mask="url(#mask-2)"
              fill="#E84249"
              fillRule="evenodd"
            >
              <rect
                id="Rectangle"
                x="0"
                y="0"
                width="27.0344828"
                height="27.0344828"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Trash;
